import { createContext } from 'react';
import Pusher from 'pusher-js';

interface IPusherContextType {
  pusher: Pusher | undefined;
}

export const PusherContext = createContext<IPusherContextType>({
  pusher: undefined,
});
